import { css } from 'styled-components';

export const cardBorder = css`
  border: 1px solid ${({ theme }) => theme.colors.grayddd};
  border-radius: 0.25rem;
`;
